// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__1Hl76","offline-title":"style_offline-title__3LLbW","offline-icon":"style_offline-icon__11tgJ"};